import React from "react";

function Loading(){
    return (
        <div className="loading rel">
            <div className="line line1" />
            <div className="line line2" />
            <div className="line line3" />
        </div>
    )
}

export default Loading;